export default{
    validForm: function (context,callback) {

        this.hideAllErrors(context);

        context.$validator.validateAll().then(() => {
            if(callback != null)
                callback();
        }).catch((error) => {
            this.showAllErrors(context);
        });
    },
    showAllErrors: function(context){
        for(var showError in context.showErrors){
            context.showErrors[showError] = true;
        }
    },

    hideAllErrors: function(context){
        for(var showError in context.showErrors){
            context.showErrors[showError] = false;
        }
    },

    hideError: function(context,key){
        context.showErrors[key] = false;
    },
    handleErrors: function(errorbag,errors){
        for (var fieldKey in errors) {
            for(var fieldError in errors[fieldKey]){
                var fieldKeyT = fieldKey.replace('configuration.','');
                errorbag.add(fieldKeyT, errors[fieldKey][fieldError]);
            }
        }
    }

}